import React, { Component } from "react";
import "./App.css";
import "./scss/app.scss";
import Login from "./pages/account/log_in/LogIn";
import Register from "./pages/account/register/Register";
import AirConRegistration from "./pages/main/AirConRegistration";
import BookAppointment from "./pages/main/BookAppointment";
import ApptPayment from "./pages/main/ApptPayment";
import ApptConfirmation from "./pages/main/ApptConfirmation";
import Services from "./pages/main/Services";
import AirConDetails from "./pages/main/AirConDetails";
import Invoices from "./pages/main/Invoices";
import InvPayment from "./pages/main/InvPayment";
import InvConfirmation from "./pages/main/InvConfirmation";
import ForgotPassword from "./pages/account/reset_pass/ForgotPassword";
import ResetPassword from "./pages/account/reset_pass/ResetPassword";
import VerifyAccount from "./pages/account/register/VerifyAccount";
import ChangeAppointment from "./pages/main/ChangeAppointment";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import ServiceRecords from "./pages/main/ServiceRecords";
import ReceiptDetails from "./pages/main/ReceiptDetails";
import PaymentGateway from "./pages/main/PaymentGateway";
import NetsConfirmation from "./pages/main/NetsConfirmation";
import NetsFailed from "./pages/main/NetsFailed";

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Switch>
            <Route exact path="/" component={Login} />
            <Route path="/register" component={Register} />
            <Route path="/register_aircon" component={AirConRegistration} />
            <Route path="/register_appt" component={BookAppointment} />
            <Route path="/change_appt" component={ChangeAppointment} />
            <Route path="/payment" component={ApptPayment} />
            <Route path="/confirmation" component={ApptConfirmation} />
            <Route path="/services" component={Services} />
            <Route path="/svc_records" component={ServiceRecords} />
            <Route path="/aircon_record" component={AirConDetails} />
            <Route path="/invoices" component={Invoices} />
            <Route path="/inv_payment" component={InvPayment} />
            <Route path="/inv_confirmation" component={InvConfirmation} />
            <Route path="/forgot_pass" component={ForgotPassword} />
            <Route path="/reset_pass" component={ResetPassword} />
            <Route path="/activate_acct" component={VerifyAccount} />
            <Route path="/receipt" component={ReceiptDetails} />
            <Route path="/paymentgateway" component={PaymentGateway} />
            <Route path="/nets_confirmation" component={NetsConfirmation} />
            <Route path="/nets_failed" component={NetsFailed} />
            <Route render={() => <h1>Page not found</h1>} />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js